common.View.create('canvas.blocks.custom.ups.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        this.element.find('.owl-carousel')
            .owlCarousel({
                loop: true,
                margin: 30,
                dots: false,
                autoplay: !this.element.find('.owl-carousel').data('show-navigation'),
                autoplayTimeout: 2500,
                responsive: {
                    0: {
                        items: 1
                    },
                    640: {
                        items: 3,
                    },
                }
            });

    }
});
